export default {
  registration: {
    headline: "Registracija",
    headline_desc: "Za registracijo računa spodaj vnesite svoje podatke.",
    back_to_login: "Nazaj na prijavo",
    register: "Registriraj",
    view: "Ogled",
    close: "Zapri",
    agreement: "To polje je obvezno.",
    description: {
      basic: "Osnovni podatki",
      current_employment: "Podatki o trenutni zaposlitvi",
      wanted_employment: "Podatki o želeni zaposlitvi"
    },
    loading_cv: "Procesiranje CVja...",
    loading_cv_description: "Podatki iz CVja lahko izpolnijo prazna polja v obrazcu.",
    fields: {
      name: {
        label: "Ime in priimek"
      },
      gender: {
        label: "Spol"
      },
      education: {
        label: "Stopnja izobrazbe"
      },
      birthday: {
        label: "Datum rojstva",
        info: "Datum rojstva potrebujemo za obdelavo in normiranje anonimiziranih podatkov."
      },
      career: {
        label: "Trenutni karierni nivo"
      },
      email: {
        label: "Elektronski naslov"
      },
      password: {
        label: "Geslo"
      },
      confirm_password: {
        label: "Ponovi geslo"
      },
      cv: {
        label: "CV",
        description: "Življenjepisa niste pripeli. Za prijavo na delovno mesto je to ključen dokument."
      },
      linkedin_url: {
        label: "LinkedIn povezava"
      },
      employer: {
        label: "Trenutni delodajalec"
      },
      industries: {
        label: "Industrija"
      },
      workfields: {
        label: "Področje dela"
      },
      expectations: {
        label: "Želena letna bruto plača (EUR)"
      },
      region: {
        label: "Regija"
      },
      phone: {
        label: "Telefonska številka"
      },
      position_title: {
        label: "Naziv delovnega mesta"
      },
      address: {
        label: "Ulica in hišna številka"
      },
      city: {
        label: "Mesto"
      },
      postal: {
        label: "Poštna številka"
      },
      country: {
        label: "Država"
      },
      education_summary: {
        label: "Dosežen naziv in izobraževalna ustanova"
      },
      notice_days: {
        label: "Odpovedni rok (št. dnevov)"
      }
    },
    gender: {
      male: "Moški",
      female: "Ženska"
    },
    password_rule: "Geslo mora vsebovati najmanj 6 znakov,<br/> vsaj eno veliko črko, malo črko, številko in poseben znak",
    confirm_error: "Potrditveno geslo se ne ujema z geslom.",
    error: "Med postopkom registracije je prišlo do napake"
  },
  registration_intro: {
    headline: "Sodelujte z nami kot Fractional Executive",
    headline_desc: "Vaše vodstvene izkušnje lahko ustvarjajo vrednost v več kot enem podjetju.",
    network: {
      building: "Competo gradi skrbno izbrano mrežo izkušenih vodij, ki želijo svoje znanje in izkušnje uporabiti v okviru fractional executive sodelovanj – pri vodenju rasti, transformacij, internacionalizacije in drugih ključnih poslovnih izzivov.",
      invitation: "V mrežo Competo Executive vabimo izkušene C-level vodje, general managerje, managing direktorje in funkcijske direktorje, ki imajo za seboj dokazljive poslovne rezultate ter jih zanima fleksibilnejša, projektno usmerjena oblika nadaljevanja kariere."
    },
    interests: {
      title: "Kaj nas zanima?",
      lead: "Poleg vaših dosedanjih izkušenj želimo razumeti predvsem:",
      items: {
        value: "na katerih področjih lahko ustvarite največjo dodano vrednost,",
        challenges: "katere poslovne izzive ste uspešno reševali,",
        projects: "kakšni projekti in podjetja vas zanimajo,",
        commitment: "koliko časa želite nameniti fractional sodelovanjem,",
        markets: "na katerih trgih ste pripravljeni delovati."
      }
    },
    next_steps: {
      title: "Kaj sledi po prijavi?",
      not_automatic: "Prijava ne pomeni avtomatične vključitve v Competo Executive.",
      interview: "Po pregledu vašega profila vas bomo, če ocenimo, da obstaja ustrezen potencial za sodelovanje, povabili na osebni pogovor. Skupaj bomo opredelili vaše ključne kompetence, izkušnje in področja, na katerih lahko kot Fractional Executive ustvarite največjo vrednost.",
      opportunity: "Ko se pojavi projekt, ki ustreza vašemu profilu, vas bomo kontaktirali in vam predstavili priložnost. Sami se odločite, ali vas sodelovanje zanima.",
      confidentiality: "Vaše podatke in profil bomo obravnavali zaupno in jih brez vašega predhodnega soglasja ne bomo predstavljali potencialnim naročnikom."
    },
    closing: {
      next_phase: "Naslednja faza vaše kariere je lahko drugačna. Ni nujno, da pomeni novo funkcijo za polni delovni čas. Lahko je priložnost, da svoje izkušnje uporabite tam, kjer so v določenem trenutku najbolj potrebne.",
      invitation: "Predstavite nam svoje izkušnje in zanimanja."
    },
    start: "Začnite prijavo",
    back_to_login: "Nazaj na prijavo"
  },
  registration_success: {
    title_success: "Registracija uspešna",
    thank_you_note: "Zahvaljujemo se za vpis v bazo iskalcev zaposlitve.",
    confirmation: "Za uspešno registracijo potrebujemo vašo potrditev, ki ste jo prejeli po elektronski pošti."
  },
  activation: {
    headline: "Aktiviranje računa",
    headline_desc: "Vaš račun se aktivira. Kmalu boste preusmerjeni..."
  },
  activation_success: {
    headline: "Račun aktiviran",
    headline_desc: "Vaš račun je bil aktiviran! Lahko nadaljujete s prijavo.",
    to_login: "Na prijavo"
  },
  activation_error: {
    headline: "Napaka pri aktivaciji računa",
    headline_desc: "Pri aktiviranju vašega računa je prišlo do težave.",
    error_msg: "Sporočilo o napaki:",
    contact: "Za več informacij kontaktirajte administratorja."
  }
}
